export default __webpack_public_path__ + "static/media/Armguards of the Vanguard.3f987e57.jpg";